module.exports = __webpack_public_path__ + "img/curitibaebus2.a8a83276.png";